import { generalMessages } from 'src/utils/messages';
import {
    faHouse,
    faArrowUpRight,
    faCar,
    faChevronLeft,
    faClockRotateLeft,
    faCopy,
    faCreditCard,
    faEdit,
    faExpand,
    faPlus,
    faSidebarFlip,
    faSpinnerThird,
    faTrashAlt,
    faUser,
    faWavePulse,
    faSpinner,
    faArrowRightToArc,
    faArrowLeftToArc,
    faBus,
    faTruck,
    faExclamationTriangle,
    faCircleXmark,
    faCircleCheck,
    faQuestionCircle,
    faCamera,
    faCalendar,
    faClock,
    faTableList,
    faHouseBuilding,
    faWandMagicSparkles,
    faScrewdriverWrench,
    faKey,
    faChevronDown,
    faCog,
    faSensor,
    faRoadBarrier,
    faSquareParking,
    faCircleExclamation,
    faCameraCctv,
    faShop,
    faClipboardUser,
    faMicrochip,
    faTag,
    faLock,
    faMoneyBill,
    faShareNodes,
    faBuildingColumns,
    faUserGroup,
    faDatabase,
    faDisplay,
    faServer,
    faCubes,
    faCalendarDays,
    faCircleDot,
    faArrowUpToArc,
    faArrowDownToArc,
    faMoneyBillTransfer,
    faEquals,
    faCloudArrowUp,
    faFileLines,
    faReceipt,
    faPlusCircle,
    faMinusCircle,
    faEye,
    faCircle1,
    faImage,
    faRotate,
    faPaperPlaneTop,
    faLockHashtag,
    faToggleOff,
    faToggleOn,
} from '@fortawesome/pro-regular-svg-icons';
import { BadgeOption } from 'src/types';

enum RangeOptions {
    WEEK = 'week',
    MONTH = 'month',
    QUARTER = 'quarter',
    YEAR = 'year',
    INDEFINITE = 'indefinite',
    CUSTOM = 'custom',
}

const rangeOptions = [
    { value: RangeOptions.WEEK, label: generalMessages.oneWeek },
    { value: RangeOptions.MONTH, label: generalMessages.oneMonth },
    { value: RangeOptions.QUARTER, label: generalMessages.threeMonths },
    { value: RangeOptions.YEAR, label: generalMessages.oneYear },
    { value: RangeOptions.INDEFINITE, label: generalMessages.indefinite },
    { value: RangeOptions.CUSTOM, label: generalMessages.custom },
];

const ICON_MAP = {
    DELETE: faTrashAlt,
    EDIT: faEdit,
    SIDE_PANEL: faSidebarFlip,
    COPY: faCopy,
    ADD: faPlus,
    EXPAND: faExpand,
    SPINNER: faSpinnerThird,
    STATIC_SPINNER: faSpinner,
    MEMBER: faUser,
    CLIENT: faCar,
    RESERVATION: faClockRotateLeft,
    SUBSCRIPTION: faCreditCard,
    WAVE_PULSE: faWavePulse,
    ARROW_UP: faArrowUpRight,
    BACK: faChevronLeft,
    ARROW_RIGHT_ARC: faArrowRightToArc,
    ARROW_LEFT_ARC: faArrowLeftToArc,
    BUS: faBus,
    TRUCK: faTruck,
    DANGER: faExclamationTriangle,
    X_MARK: faCircleXmark,
    CHECK: faCircleCheck,
    TABLE_LIST: faTableList,
    QUESTION: faQuestionCircle,
    CAMERA: faCamera,
    CALENDAR: faCalendar,
    TIME: faClock,
    RESIDENT: faHouseBuilding,
    SERVICE: faScrewdriverWrench,
    CUSTOM_TEMPLATE: faWandMagicSparkles,
    KEY: faKey,
    DOWN: faChevronDown,
    CARD: faCreditCard,
    CASH: faMoneyBill,
    ONLINE: faShareNodes,
    BANK: faBuildingColumns,
    COG: faCog,
    HOME: faHouse,
    SENSOR: faSensor,
    ROAD_BARRIER: faRoadBarrier,
    SQUARE_PARKING: faSquareParking,
    CIRCLE_EXCLAMATION: faCircleExclamation,
    CCTV_CAMERA: faCameraCctv,
    SHOP: faShop,
    USERS: faUserGroup,
    MEMBERSHIP_CARD: faClipboardUser,
    MEMBERSHIP_CHIP: faMicrochip,
    MEMBERSHIP_TAG: faTag,
    PASSWORD: faLock,
    STORAGE: faDatabase,
    API_CALLS: faShareNodes,
    DEVICES: faDisplay,
    CALLS: faServer,
    SEATS: faUserGroup,
    UNITS: faCubes,
    SCHEDULED: faCalendarDays,
    PAST: faClockRotateLeft,
    CURRENT: faCircleDot,
    FROZEN: faSpinner,
    INCREMENT: faArrowUpToArc,
    DECREMENT: faArrowDownToArc,
    SET: faEquals,
    REFUND: faMoneyBillTransfer,
    UPLOAD: faCloudArrowUp,
    INVOICE: faFileLines,
    RECEIPT: faReceipt,
    PLUS_CIRCLE: faPlusCircle,
    MINUS_CIRCLE: faMinusCircle,
    VIEW: faEye,
    SINGLE: faCircle1,
    IMAGE: faImage,
    ROTATE: faRotate,
    SENDING: faPaperPlaneTop,
    LOCK: faLockHashtag,
    TOGGLE_OFF: faToggleOff,
    TOGGLE_ON: faToggleOn,
};

export { rangeOptions, RangeOptions, ICON_MAP };

export const booleanBadgeOptions: Record<string, BadgeOption> = {
    true: {
        label: generalMessages.yes,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    false: {
        label: generalMessages.no,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
};
